export default {
  id: "PosterView",
  code: "CN",
  text: {
    'Registration Start Time': '报名开始时间',
    'Total Registered: {numberStr}': '目前报名: {numberStr}人',
    'Total Registered: ': '目前报名人数: ',

    'Registration Start Time': '报名开始日期',
    'Total Registered': '目前报名',

    'Course Fee: ${price}': '课程费用: ${price}',
    'Item': '项目',
    'Items': '项目',
    'Register Now': '立即报名',
    'Registered': '报名人数',
    'Deadline': '报名结束日期',
    'None': '无限期',
    'Note: Currently we only accept online registration and offline payment.': '提示：报名目前只接受线上注册，线下缴费。',
    "Basic Poster": '普通海报',
    "Enrollment Registration": '招生注册',
    "Event Registration": '活动门票',
    "Survey": '调查投票',
    'Sorry we are unable to take WeChat registertion at the monment, please register with PC broswers': '抱歉我们暂时不支持微信付款报名，请用电脑浏览器打开报名。',
    '': '',
    'Confirm': '确认',
    'No Limit':'无上限',
  }
}



// WEBPACK FOOTER //
// ./src/shared/PosterView/locale.js